import axios from 'axios';

const state = {
    all: [],
};

const actions = {
    async create({ commit }, customer) {
        const { data } = await axios.post(window.route('api.customers.store'), customer);
        commit('add', data);
        return data;
    },

    delete({ commit }, customer) {
        return axios.delete(window.route('api.customers.destroy', customer.id))
            .then(() => {
                commit('delete', customer);
            });
    },

    find({ commit }) {
        return axios.get(window.route('api.customers.index'))
            .then(({ data }) => {
                commit('set', data.data);
            });
    },

    update({ commit }, customer) {
        return axios.put(window.route('api.customers.update', customer.id), customer)
            .then(({ data }) => {
                commit('update', data);
                return data;
            });
    },
};

const mutations = {
    add(state, customer) {
        state.all.push(customer);
    },

    delete(state, customer) {
        const index = state.all.findIndex(c => c.id === customer.id);
        state.all.splice(index, 1);
    },

    set(state, customers) {
        state.all = customers;
    },

    update(state, customer) {
        const index = state.all.findIndex(c => c.id === customer.id);
        state.all.splice(index, 1, customer);
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
